import React from 'react';
import { ReviewNeededBadge, fieldNeedsReview } from './ReviewNeededBadge';

/**
 * Reusable SEO fields component for admin forms
 * @param {object} seoData - {seo_title, seo_description}
 * @param {function} onChange - Change handler for field updates
 * @param {array} missingFields - Array of field names that need review (from _metadata.missing_fields)
 */
export const SEOFields = ({ seoData = {}, onChange, missingFields = [] }) => {
  const { seo_title = '', seo_description = '' } = seoData;

  const handleChange = (field, value) => {
    onChange({ ...seoData, [field]: value });
  };

  return (
    <div className="pt-6 border-t-2 border-[#E5E7EB]">
      <h2 className="text-lg font-bold text-[#111827] mb-4">SEO Settings</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-semibold text-[#111827] mb-2">
            SEO Title
            <ReviewNeededBadge fieldName="seo_title" missingFields={missingFields} />
          </label>
          <input
            type="text"
            value={seo_title}
            onChange={(e) => handleChange('seo_title', e.target.value)}
            className={`w-full px-4 py-2 border-2 rounded-lg focus:outline-none ${
              fieldNeedsReview('seo_title', missingFields)
                ? 'border-amber-300 focus:border-amber-400 bg-amber-50'
                : 'border-[#E5E7EB] focus:border-[#1E40AF]'
            }`}
            placeholder="Custom page title for search engines"
            maxLength={60}
          />
          <p className="text-xs text-[#6B7280] mt-1">{seo_title.length}/60 characters (recommended max)</p>
        </div>

        <div>
          <label className="block text-sm font-semibold text-[#111827] mb-2">
            SEO Description
            <ReviewNeededBadge fieldName="seo_description" missingFields={missingFields} />
          </label>
          <textarea
            value={seo_description}
            onChange={(e) => handleChange('seo_description', e.target.value)}
            rows={3}
            className={`w-full px-4 py-2 border-2 rounded-lg focus:outline-none ${
              fieldNeedsReview('seo_description', missingFields)
                ? 'border-amber-300 focus:border-amber-400 bg-amber-50'
                : 'border-[#E5E7EB] focus:border-[#1E40AF]'
            }`}
            placeholder="Brief description for search engine results"
            maxLength={160}
          />
          <p className="text-xs text-[#6B7280] mt-1">{seo_description.length}/160 characters (recommended max)</p>
        </div>
      </div>
    </div>
  );
};

export default SEOFields;
